import { Helmet } from 'react-helmet';
import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MatomoHelmet = () => {
  const {
    i18n
  } = useLingui();
  const title = i18n._({
    id: `conversational-carlead.page.title`,
    message: ''
  });
  return /*#__PURE__*/_jsxs(Helmet, {
    children: [title && /*#__PURE__*/_jsx("title", {
      children: title
    }), /*#__PURE__*/_jsx("meta", {
      name: "robots",
      content: "noindex,follow"
    }), /*#__PURE__*/_jsx("script", {
      children: `
          var _paq = window._paq = window._paq || [];
          /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
          _paq.push(['trackPageView']);
          _paq.push(['enableLinkTracking']);
          (function() {
            var u="//mat.mautomagic.com/";
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', '3']);
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
          })();
        `
    })]
  });
};
export default MatomoHelmet;